var jsContext = require.context('../resources/static/scripts', true, /\.js$/);
jsContext.keys().map(jsContext);

var htmlContext = require.context('../resources/static/scripts', true, /\.html$/);
htmlContext.keys().map(htmlContext);

require('../sass/main.scss');


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/bundle.js
// module id = 420
// module chunks = 0